const { map, reduce } = require('lodash')

/**
* Sleep promise for given ms
* @param {number} ms - Milliseconds
* @return {object} - Sleep promise
*/
export const sleep = async ms => new Promise(resolve => setTimeout(resolve, ms))

/**
 * Asynchronous parallel map
 */
export const mapAll = async (collection, fn) => Promise.all(map(collection, fn))

/**
 * Asynchronous sequential reduce
 */
export const reduceAsync = async (collection, fn, initial) => reduce(
	collection,
	async (previous, value, key, arr) => {
		const acc = await previous
		return fn(acc, value, key, arr)
	}, Promise.resolve(initial),
)

/**
 * Asynchronous sequential map
 */
export const mapAsync = async (collection, fn) => reduceAsync(
	collection,
	async (acc, value, key, arr) => {
		const item = await fn(value, key, arr)
		acc.push(item)
		return acc
	},
	[],
)
